const dropdowns = document.querySelectorAll('.js-dropdown');

const closeDropdown = (dropdown) => {
    const btn = dropdown.querySelector('.js-dropdown-btn');
    btn.setAttribute('aria-expanded', 'false');
};

dropdowns.forEach((dropdown) => {
    const btn = dropdown.querySelector<HTMLButtonElement>('.js-dropdown-btn');
    const items = dropdown.querySelectorAll<HTMLButtonElement>('.js-dropdown-item');

    let currentFocusIndex = 0;

    const moveFocus = (availableItems, index) => {
        currentFocusIndex = index;
        availableItems[index].focus();
    };

    items.forEach((item) => {
        const itemBtn = item.querySelector('button');

        item.addEventListener('click', () => {
            closeDropdown(dropdown);
        });

        item.addEventListener('keydown', (e) => {
            const availableItems = dropdown.querySelectorAll<HTMLButtonElement>(
                '.js-dropdown-item[style="display: block;"]',
            );
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                closeDropdown(dropdown);
                if (itemBtn) itemBtn.click();
                btn.focus();
            }
            if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (currentFocusIndex > 0) moveFocus(availableItems, currentFocusIndex - 1);
                else moveFocus(availableItems, availableItems.length - 1);
            }
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (currentFocusIndex < availableItems.length - 1)
                    moveFocus(availableItems, currentFocusIndex + 1);
                else moveFocus(availableItems, 0);
            }
            if (e.key === 'Tab' || (e.shiftKey && e.key === 'Tab')) {
                closeDropdown(dropdown);
            }
        });
    });

    btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded');
        btn.setAttribute('aria-expanded', expanded === 'true' ? 'false' : 'true');
        const availableItems = dropdown.querySelectorAll<HTMLButtonElement>(
            '.js-dropdown-item[style="display: block;"]',
        );

        if (expanded === 'false') {
            document.addEventListener('click', (e: any) => {
                if (!dropdown.contains(e.target)) closeDropdown(dropdown);
            });
            setTimeout(() => {
                availableItems[0].focus();
            }, 100);
        }
    });
});
